import React from 'react';
import { CMSFindYourFit, CMSFindYourFitChart } from './types';

const FindYourFitChart = ({ chart }: { chart: CMSFindYourFitChart }) => {
  return (
    <table className='tw:mx-1 tw:my-auto tw:w-full tw:table-auto tw:border tw:border-body tw:md:mx-4'>
      <thead>
        <tr>
          <th className='tw:bg-body tw:p-2 tw:text-center tw:font-body tw:text-base tw:font-bold tw:uppercase tw:text-white tw:sm:p-3 tw:md:p-5'>
            {chart.attributes.title}
          </th>
        </tr>
      </thead>
      <tbody>
        {chart.attributes.values.map((val) => (
          <tr
            key={`${chart.attributes.title}-${val.attributes.value}`}
            className='tw:first:[&>td]:pt-4 tw:last:[&>td]:pb-4'>
            <td className='tw:px-[5px] tw:py-2 tw:text-center tw:font-body tw:text-base tw:font-bold tw:text-body tw:sm:px-2'>
              {val.attributes.value}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

type Props = {
  component: CMSFindYourFit;
};

const FindYourFit = ({ component }: Props) => {
  const {
    children: charts,
    attributes: { note },
  } = component;

  return (
    <div id='FindYourFit' className='tw:mt-10 tw:bg-neutrals-eggshell tw:px-4 tw:py-16 tw:lg:mt-20'>
      <h2 className='tw:mb-8 tw:text-center tw:text-2xl tw:font-bold tw:text-body tw:lg:text-3xl'>
        Find Your Fit
      </h2>

      <div className='tw:mx-auto tw:flex tw:max-w-[800px] tw:justify-between tw:overflow-y-auto tw:pb-3'>
        {charts.map((chart) => (
          <FindYourFitChart key={chart.id} chart={chart} />
        ))}
      </div>

      {note && (
        <p
          className='tw:mx-auto tw:mt-5 tw:text-center tw:text-sm tw:font-normal tw:text-body tw:[&>b]:font-bold tw:[&>strong]:font-bold'
          dangerouslySetInnerHTML={{ __html: note }}></p>
      )}
    </div>
  );
};

export default FindYourFit;
